import CryptoJS from "crypto-js";

export const encrypt = (data) => {
  return new Promise((resolve, reject) => {
      try {
          const rawData = JSON.stringify(data.data);
          const key = CryptoJS.enc.Latin1.parse("Z3us3ncryPtEd.K3Y.Z3us3ncryPtEd+");
          const iv = CryptoJS.lib.WordArray.random(128 / 8);
          const cipherData = CryptoJS.AES.encrypt(rawData, key, { iv: iv });
          const cipher = cipherData.iv.concat(cipherData.ciphertext);
          resolve({ data: CryptoJS.enc.Base64.stringify(cipher) });
      }
      catch (e) {
          reject("Missing values to encrypt");
      }
  });
};

export const decrypt = (data) => {
  return new Promise((resolve, reject) => {
      try {
          const rawData = CryptoJS.enc.Base64.parse(data.data);
          const key = CryptoJS.enc.Latin1.parse("Z3us3ncryPtEd.K3Y.Z3us3ncryPtEd+");
          const iv = CryptoJS.enc.Latin1.parse(rawData.toString().substring(0, 16));
          const plaintextData = CryptoJS.AES.decrypt({ ciphertext: rawData }, key, { iv: iv });
          let plaintext = plaintextData.toString(CryptoJS.enc.Latin1);
          plaintext = plaintext.replace(plaintext.substring(0, 16), '');
          resolve({ data: JSON.parse(decodeURIComponent(escape(plaintext))) });
      }
      catch (e) {
          reject("String cannot be decrypted");
      }
  })
}

export const LAYOUTS = {
  EMPLOYEES: 'Layouts/Layout_Empleados.xlsm',
  CUSTOMIZED: 'Layouts/Personalizado.xlsm',
};

export const FILE_EXTENSION = {
  PDF: 'pdf',
  PNG: 'png',
  JPEG: 'jpeg',
  JPG: 'jpg',
  MP3: 'mp3',
  MP4: 'mp4',
  XLSX: 'xlsx',
  XLSM: 'xlsm'
};

export const TIME_PICKER_LIST = [
  "00:00",
  "01:00",
  "02:00",
  "03:00",
  "04:00",
  "05:00",
  "06:00",
  "07:00",
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
  "20:00",
  "21:00",
  "22:00",
  "23:00"
]

export const BACKGROUND: string = 
  'https://s3.amazonaws.com/prod.zeus.beneficios.financieros/assets/zeus-front-podcast/categorias2024/08/01/image10-58-43.png'
export const UPLOAD_IMAGE: string = 
  'https://s3.amazonaws.com/dev.structure.files/assets/zeus-front-podcast/cargar_imagen.png'

export const MODEL_IMAGES = [
  { imagenUrl: BACKGROUND},
  { imagenUrl: BACKGROUND},
  { imagenUrl: BACKGROUND}
]

export const TAGS = [
  { etiquetaImagen: ''},
  { etiquetaImagen: ''},
  { etiquetaImagen: ''}
]